import styled from "styled-components";
import { useGetActiveFaults } from "../../hooks/BWOS/useGetActiveFaults";
import Spinner from "../../interface/Spinner";
import FaultListItem from "./FaultListItem";
import WIOSSLoader from "../../interface/WIOSSLoader";

const FaultContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 1rem;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-bottom: 1rem;
  margin-top: 0.4rem;
  overflow-x: auto; /* Optional: Allows horizontal scrolling if there are many cards */
`;

const NoContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  margin-left: 1rem;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 0.8em;
  backdrop-filter: blur(30px);
  background-color: var(--backdrop-color);
  border: 1px solid var(--color-grey-200);
  cursor: pointer;
  box-shadow: var(--shadow-div-md);
`;

const StyledHeading = styled.h5`
  color: var(--color-grey-500);
  padding-top: 1em;
  padding-left: 2em;
`;

function StatusActiveFaults() {
  const { data, isLoading, isError, error } = useGetActiveFaults();

  // Check if the response indicated no content
  if (data && data.noContent) {
    return <div>No backlogged orders.</div>;
  }

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  if (!data.data) {
    return (
      <NoContentContainer>
        <WIOSSLoader text="NO FAULTS FOUND" />
      </NoContentContainer>
    );
  }

  console.log("Faults", data.data);

  return (
    <FaultContainer>
      <StyledHeading>Active Faults</StyledHeading>
      {data.data.map((fault) => (
        <FaultListItem key={fault.id} fault={fault} />
      ))}
    </FaultContainer>
  );
}

export default StatusActiveFaults;
